/**
 * ###################################
 * @description auth path
 * ###################################
 */
export enum AUTH_PATH {
  // auth path
  HOME_PATH = '/',
  SIGNIN_PATH = `/signin`,
  OAUTH_CALLBACK_PATH = `/auth/callback/:kind`,

  // term path
  TERM_PATH = '/term',
  SERVICE_TERM_PATH = '/service-term',
  PRIVATE_TERM_PATH = '/private-term',
  ACCOUNT_TERM_PATH = '/account-term',
}
